// Global scripts from WP
import Animate from "./modules/Animate";
import CountUp from "./modules/CountUp";
import Reveal from "./modules/Reveal";
import Header from "./modules/Header";
import Slider from "./modules/components/Slider";
import ShopFilters from "./modules/ShopFilters";
import SubscribeNewsletter from "./modules/components/SubscribeNewsletter";
import ProductHero from "./modules/components/ProductHero";
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
// Proof of a real browser for the filter-URL bot guard (mu-plugins/cube-bot-guard.php):
// filter URLs without this cookie get a JS challenge page first. Set on every page
// view, so anyone who browses before filtering never sees it.
document.cookie = 'upyard_js=1; path=/; max-age=2592000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
// Init gsap animations
new Animate(); // How to use - look in file
// Init the site-wide scroll reveal (every block fades up as it comes into view)
new Reveal();
// Init stat counters (hero figures count up on first scroll into view)
document.querySelectorAll('[data-count-up]').forEach((element) => {
    CountUp.create(element);
});
// Init header (mobile menu + submenu toggles)
const headerEl = document.querySelector('[data-header]');
if (headerEl) {
    new Header(headerEl);
}
// Init slider components
const sliderComponents = document.querySelectorAll('.slider-default');
sliderComponents.forEach((component) => {
    new Slider(component);
});
// Init shop filtering (swaps the results in place instead of reloading the page)
const shopResults = document.querySelector('[data-shop-results]');
if (shopResults) {
    new ShopFilters(shopResults);
}
// Init subscribe newsletter components
const subscribeNewsletterComponents = document.querySelectorAll('.subscribe-newsletter');
subscribeNewsletterComponents.forEach((component) => {
    new SubscribeNewsletter(component);
});
// Init single-product hero (option tags + FAQ accordion)
document.querySelectorAll('[data-product-hero]').forEach((component) => {
    new ProductHero(component);
});
